import ParagraphBlock from "./ParagraphBlock"

export default ParagraphBlock
